/* DD0 Featured reviews slider (main-product `review_quote` block).
   Scroll-snap does the sliding; this element only adds dots, arrows and autoplay,
   so with JS disabled the cards still swipe natively. */
(() => {
  if (customElements.get('dd0-quote-slider')) return;

  class DD0QuoteSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      if (!this.viewport) return;
      this.slides = Array.from(this.viewport.children);
      if (this.slides.length < 2) return;
      this.index = 0;
      this.dots = [];

      const dotsWrap = this.querySelector('[data-dots]');
      if (dotsWrap) {
        this.slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'dd0-rvq__dot';
          dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dot.addEventListener('click', () => this.goTo(i));
          dotsWrap.appendChild(dot);
          this.dots.push(dot);
        });
      }
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.index + 1));

      this.viewport.addEventListener(
        'scroll',
        () => {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = null;
            this._sync();
          });
        },
        { passive: true }
      );
      this._sync();

      if (this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this._delay = (parseFloat(this.dataset.speed) || 5) * 1000;
        this._play();
        /* Pause while the visitor is on the slider (hover or touch). */
        this.addEventListener('pointerenter', () => clearInterval(this._timer));
        this.addEventListener('pointerleave', () => this._play());
      }
    }

    disconnectedCallback() {
      clearInterval(this._timer);
    }

    _play() {
      clearInterval(this._timer);
      this._timer = setInterval(() => this.goTo(this.index + 1), this._delay);
    }

    _sync() {
      const stride = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      if (stride <= 0) return;
      this.index = Math.min(this.slides.length - 1, Math.max(0, Math.round(this.viewport.scrollLeft / stride)));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }

    goTo(i) {
      const n = this.slides.length;
      const target = ((i % n) + n) % n;
      this.viewport.scrollTo({
        left: this.slides[target].offsetLeft - this.slides[0].offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('dd0-quote-slider', DD0QuoteSlider);
})();
